var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Content Builder")]),_c('ContentBuilder',{model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }